export default __webpack_public_path__ + "static/media/per-linkedin.29425f8a.svg";